__webpack_require__.p = "https://http2.mlstatic.com/frontend-assets/homes-palpatine/";